/// <reference types="@angular/localize" />

import { CSP_NONCE, enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

const bootstrap = () =>
	// Angular 21: per un'app a NgModule il rilevamento delle modifiche basato su zone.js va chiesto esplicitamente
	// (provideZoneChangeDetection); i provider vanno in applicationProviders.
	platformBrowserDynamic().bootstrapModule(AppModule, {
		applicationProviders: [
			provideZoneChangeDetection(),
			{
				provide: CSP_NONCE,
				useValue: 'randomNonceGoesHere',
			},
		],
	});

bootstrap().catch(err => console.log(err));
